import { useState, useEffect } from "react";
import { useAuthenticatedApiClient } from "./useAuthenticatedApiClient";
import FinancialApplicationApiClient from "@/api/financialApplicationApiClient";
import { ConsumerPortalMetrics } from "@/types/ConsumerPortal";
import { AppToasterV2 } from "@ucl/library";

export interface UseConsumerPortalReturn {
  metrics: ConsumerPortalMetrics | null;
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const useConsumerPortal = (): UseConsumerPortalReturn => {
  const [metrics, setMetrics] = useState<ConsumerPortalMetrics | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const financialApplicationApiClient = useAuthenticatedApiClient(FinancialApplicationApiClient);

  const fetchMetrics = async () => {
    try {
      setIsLoading(true);
      setError(null);

      const response = await financialApplicationApiClient.getConsumerPortalMetrics();
      setMetrics(response);
    } catch (err) {
      console.error("Failed to fetch consumer portal metrics:", err);
      setError("Failed to load portal metrics");
      AppToasterV2.showFailedActionToaster("Failed to load portal metrics");
    } finally {
      setIsLoading(false);
    }
  };

  const refetch = async () => {
    await fetchMetrics();
  };

  useEffect(() => {
    fetchMetrics();
  }, []);

  return {
    metrics,
    isLoading,
    error,
    refetch,
  };
};
